import { doesIdentityRequireRefresh, isIdentityExpired, memoizeIdentityProvider, } from "@smithy/core";
import { HttpApiKeyAuthLocation, } from "@smithy/types";
import { getSmithyContext } from "@smithy/util-middleware";
export const defaultApiHttpAuthSchemeParametersProvider = async (config, context, input) => {
    return {
        operation: getSmithyContext(context).operation,
    };
};
function createSmithyApiHttpApiKeyAuthHttpAuthOption(authParameters) {
    return {
        schemeId: "smithy.api#httpApiKeyAuth",
        signingProperties: {
            name: "admin-api-key",
            in: HttpApiKeyAuthLocation.HEADER,
            scheme: undefined,
        },
    };
}
;
function createSmithyApiHttpBasicAuthHttpAuthOption(authParameters) {
    return {
        schemeId: "smithy.api#httpBasicAuth",
    };
}
;
function createSmithyApiHttpBearerAuthHttpAuthOption(authParameters) {
    return {
        schemeId: "smithy.api#httpBearerAuth",
    };
}
;
function createSmithyApiNoAuthHttpAuthOption(authParameters) {
    return {
        schemeId: "smithy.api#noAuth",
    };
}
;
export const defaultApiHttpAuthSchemeProvider = (authParameters) => {
    const options = [];
    switch (authParameters.operation) {
        case "AdyenWebhook":
            {
                options.push(createSmithyApiHttpBasicAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "GetFileById":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "CreateOrder":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "CreateOrderAsPartner":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "CreatePaymentSessionForOrder":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "DeletePowerOfAttorny":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "GetOrderByAccessId":
            {
                options.push(createSmithyApiHttpBearerAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "GetOrderJWTByAccessId":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "SendPOAEMail":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "UpdateOrderData":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "UploadPowerOfAttorny":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "CreatePartner":
            {
                options.push(createSmithyApiHttpApiKeyAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "GetPartnerById":
            {
                options.push(createSmithyApiHttpApiKeyAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "GetPartnerBySubfolder":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "GetPartners":
            {
                options.push(createSmithyApiHttpApiKeyAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "UpdatePartner":
            {
                options.push(createSmithyApiHttpApiKeyAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "GetAllProductsForPartner":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "GetProductsForPartner":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        case "UpdateProduct":
            {
                options.push(createSmithyApiNoAuthHttpAuthOption(authParameters));
                break;
            }
            ;
        default:
            {
                options.push(createSmithyApiHttpBearerAuthHttpAuthOption(authParameters));
                options.push(createSmithyApiHttpBasicAuthHttpAuthOption(authParameters));
            }
            ;
    }
    ;
    return options;
};
export const resolveHttpAuthSchemeConfig = (config) => {
    const apiKey = memoizeIdentityProvider(config.apiKey, isIdentityExpired, doesIdentityRequireRefresh);
    const token = memoizeIdentityProvider(config.token, isIdentityExpired, doesIdentityRequireRefresh);
    return {
        ...config,
        apiKey,
        token,
    };
};
